class Accordion{
	constructor($dom, index){
		this.btn 	= $dom;
		this.index 	= index;
		this.target = $dom.parentNode.parentNode.querySelector("[data-accordion]");
		
		//console.log(this);
		this.nav();
	}
	nav(){
		this.btn.removeEventListener("click", this.toggleAccordion.bind(this), false);
		this.btn.addEventListener("click", this.toggleAccordion.bind(this), false);
	}
	toggleAccordion(e){
		e.preventDefault();
		let $this = e.currentTarget;
		let $inr = this.target.querySelector("ul");
		let _h = $inr.clientHeight;
		let $target = this.target;
		if( $target.classList.contains("open") ){
			$target.style.height = _h + "px";
			setTimeout(function(){
				_h = 0;
				$target.style.height = _h + "px";
				$target.classList.remove("open");
			}, 10);
		}else{
			$target.classList.add("open");
			$target.style.height = _h + "px";
			$target.addEventListener("transitionend", function(){
				$target.style.height = "auto";
			}, {
				"once": true
			});
		}
		//console.log(_h);
	}
}
export let accordions = {
	arry: [],
	init: function(){
		let $accordions = document.querySelectorAll("button[data-toggle-accordion]");
		$accordions.forEach( ($a, index) => {
			accordions.arry[index] = new Accordion($a, index);
		});
	}
}